import Logo from './Logo'

export * from './HeaderLogo'

export default Logo
